/** Original navigation ids (NAV, L400-420) → URL paths. */
export const ROUTES: Record<string, string> = {
  dashboard: '/',
  ai: '/ai',
  dayBoard: '/day-board',
  calendar: '/calendar',
  pipeline: '/pipeline',
  customers: '/customers',
  orders: '/orders',
  logistics: '/logistics',
  products: '/products',
  pricing: '/pricing',
  pos: '/pos',
  commission: '/commission',
  finance: '/finance',
  accounting: '/accounting',
  suppliers: '/suppliers',
  inventory: '/inventory',
  team: '/team',
  attendance: '/attendance',
  reports: '/reports',
  statistics: '/statistics',
  appointments: '/appointments',
  seasonal: '/seasonal',
  quality: '/quality',
  settings: '/settings',
};

/** Pages added by the migration (not in the original navigation), shown after the original items. */
export const EXTRA_NAV = [{ id: 'statistics', label: 'الإحصائيات', g: 'التقارير' }];

/** Pages of the original that were implemented but not in its navigation (SRC-17). */
export const DORMANT_NAV = [
  { id: 'appointments', label: 'المواعيد والمقابلات', g: 'وحدات إضافية' },
  { id: 'seasonal', label: 'التخطيط الموسمي', g: 'وحدات إضافية' },
  { id: 'quality', label: 'الجودة والشكاوى', g: 'وحدات إضافية' },
];
